import classNames from "classnames";
import { NodeStates } from "../../build/types";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import { BuilderComponentProps } from "../BuilderInterface";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";
import "./style.scss";

const BuilderVismaPage = ({ node, children, actionCallbacks, builderProps, disabled, selected }: BuilderComponentProps) => {
    const { id, attr, stateManager } = node;
    const { setElement, states } = useInteractionStates<HTMLDivElement>();

    const builderVismaPageClass = classNames("builder-visma-page", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { nodeState, selectCallback, outlineCallback } = builderProps;

        return (
            <div
                {...attr}
                className={builderVismaPageClass}
                style={getCompoundStyle({
                    node,
                    stateStyle: getStateStyleForBuilder(stateManager, nodeState, "attr_style")
                })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                draggable="false"
            >
                {children}
            </div>
        );
    } else {
        const { style, ...rest } = attr || {};

        const extraStates = (
            disabled || selected ? [selected && NodeStates.SELECTED, disabled && NodeStates.DISABLED].filter(Boolean) : undefined
        ) as NodeStates[];

        const divStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: getCompoundStyle({ node }),
            stateManager,
            paths: ["attr_style"],
            ...(extraStates ? { extraStates } : {})
        });

        return (
            <div ref={setElement} style={divStyle} id={id} {...rest} {...actionCallbacks} className={builderVismaPageClass}>
                {children}
            </div>
        );
    }
};

export default BuilderVismaPage;
